import script from "./MultiOrderSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiOrderSelect.vue?vue&type=script&setup=true&lang=js"

import "./MultiOrderSelect.vue?vue&type=style&index=0&id=6e49a004&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e49a004"]])

export default __exports__